import CardTenantInfo from './CardTenantInfo.vue';

export default CardTenantInfo;
